import { request } from "../utils/request.js"

export const fundCollectOrder_exportForManage = (pojo, args) => request({
    url: 'fundCollectOrder/exportForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const fundCollectOrder_findPageForManage = (pojo, args) => request({
    url: 'fundCollectOrder/findPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const fundCollectOrder_findPageListForManage = (pojo, args) => request({
    url: 'fundCollectOrder/findPageListForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const fundCollectOrder_findPageForCurrentUser = (pojo, args) => request({
    url: 'fundCollectOrder/findPageForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const fundCollectOrder_findPageListForCurrentUser = (pojo, args) => request({
    url: 'fundCollectOrder/findPageListForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})


export const fundCollectOrder_saveIntoDraft = (pojo, args) => request({
    url: 'fundCollectOrder/saveIntoDraft',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const fundCollectOrder_saveIntoDraftAndSubmit = (pojo, args) => request({
    url: 'fundCollectOrder/saveIntoDraftAndSubmit',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const fundCollectOrder_update = (pojo, args) => request({
    url: 'fundCollectOrder/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const fundCollectOrder_updateAndSubmit = (pojo, args) => request({
    url: 'fundCollectOrder/updateAndSubmit',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const fundCollectOrder_submitById = (id, args) => request({
    url: 'fundCollectOrder/submitById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const fundCollectOrder_deleteById = (id, args) => request({
    url: 'fundCollectOrder/deleteById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const fundCollectOrder_approval = (pojo, args) => request({
    url: 'fundCollectOrder/approval',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const fundCollectOrder_findById = (id, args) => request({
    url: 'fundCollectOrder/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const fundCollectOrder_findVoById = (id, args) => request({
    url: 'fundCollectOrder/findVoById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/fundCollectOrder.js